import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { BaseController } from '../../../../core/abstractions/base.controller';
import { RegistrationStatusEnum } from '../../../../models/enums/registration-status.enum';
import { VotingInstructionsEnumExtensions } from '../../../../models/enums/voting-instructions.enum';
import { GmShareholderSummaryModel } from '../../../../models/gm-shareholder-summary.model';
import { GmShareholderModel } from '../../../../models/gm-shareholder.model';
import { ListGmShareholderModel } from '../../../../models/list-gm-shareholder.model';
import { GmShareholdersResource } from '../../../../services/resources/gm-shareholders.resource';

@Component({
    selector: 'sl-gm-shareholders-view',
    standalone: false,
    templateUrl: './gm-shareholders-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gm-shareholders-view.component.scss'
})
export class GmShareholdersViewComponent extends BaseController<GmShareholderModel, GmShareholderSummaryModel, ListGmShareholderModel> {
    readonly instructionNewAgendaItemDescriptionKey = computed(() => {
        const recordSummary = this.recordSummary();
        return recordSummary?.registrationStatus === RegistrationStatusEnum.IndependentRepresentative
            ? VotingInstructionsEnumExtensions.getDescriptionKey(recordSummary.instructionNewAgendaItem)
            : undefined;
    });

    readonly instructionAgendaItemChangeDescriptionKey = computed(() => {
        const recordSummary = this.recordSummary();
        return recordSummary?.registrationStatus === RegistrationStatusEnum.IndependentRepresentative
            ? VotingInstructionsEnumExtensions.getDescriptionKey(recordSummary.instructionAgendaItemChange)
            : undefined;
    });

    protected override readonly _entityResource = inject(GmShareholdersResource);
}
